<template>
    <span><img class="coin" :src="require('../assets/coin.png')"/></span>
</template>

<script>
export default {}
</script>

<style>
.coin {
    width: 3vh;
    height: 3vh;
    margin: 0px 10px 0px 10px;
}
</style>
